/**
 * 상담 모드 API Client
 * V1153: 조직 단위 상담 모드 관리
 */

import apiClient from "./client";
import type {
  ConsultationModeConfig,
  ConsultationModeUpdateRequest,
} from "@/types/consultationMode";

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
}

export const consultationModeApi = {
  /**
   * 현재 조직의 상담 모드 설정 조회
   */
  getConfig: async (): Promise<ConsultationModeConfig> => {
    const response = await apiClient.get<ApiResponse<ConsultationModeConfig>>(
      "/api/consultation-mode",
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || "설정 조회 실패");
    }
    return response.data.data;
  },

  /**
   * 상담 모드 변경
   */
  updateMode: async (data: ConsultationModeUpdateRequest): Promise<void> => {
    const response = await apiClient.put<ApiResponse<void>>(
      "/api/consultation-mode",
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "모드 변경 실패");
    }
  },
};
